import { useEffect, useState } from "react";
import { wpImg } from "@/lib/api";

const SLIDES = [
  {
    url: wpImg("https://themexbd.com/gogrin/mosque/wp-content/uploads/2022/12/H2-slider2.jpg"),
    eyebrow: "Assalamu Alaikum",
    title1: "Welcome to",
    title_italic: "Flint Islamic",
    title2: "Center.",
  },
  {
    url: wpImg("https://flintislamiccenter.com/wp-content/uploads/2022/12/footer-bg.jpg"),
    eyebrow: "Unity · Compassion · Community",
    title1: "Following the way",
    title_italic: "of the Prophet",
    title2: "Muhammad ﷺ.",
  },
  {
    url: wpImg("https://flintislamiccenter.com/wp-content/uploads/2024/06/Screenshot_20240622-013423.png"),
    eyebrow: "Mark your calendar",
    title1: "Events that",
    title_italic: "bring us",
    title2: "together.",
  },
];

export default function HeroSlider({ children }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % SLIDES.length), 6500);
    return () => clearInterval(t);
  }, []);
  const s = SLIDES[idx];

  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-navy">
      {/* Slides */}
      {SLIDES.map((sl, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
          style={{ opacity: i === idx ? 1 : 0 }}
          aria-hidden={i !== idx}
        >
          <img
            src={sl.url}
            alt=""
            className={`w-full h-full object-cover ${i === idx ? "kenburns" : ""}`}
            key={`img-${i}-${idx}`}
            loading={i === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}
      <div className="absolute inset-0 hero-overlay" />
      <div className="absolute inset-0 pattern-girih opacity-10" />

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-24 w-full grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 text-cream">
          <div
            key={`eyebrow-${idx}`}
            className="inline-flex items-center gap-2 rounded-full bg-cream/10 border border-cream/20 px-4 py-1.5 backdrop-blur slide-in"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
            <span className="text-[10px] uppercase tracking-[0.25em] text-gold">{s.eyebrow}</span>
          </div>
          <h1 key={`title-${idx}`} className="display text-5xl md:text-6xl lg:text-7xl mt-6 text-cream slide-in">
            {s.title1}<br />
            <span className="italic text-gold">{s.title_italic}</span>
            {s.title2 ? <><br />{s.title2}</> : null}
          </h1>
          {children}
        </div>

        {/* Slide indicators */}
        <div className="absolute bottom-10 left-6 md:left-10 flex gap-2 z-20">
          {SLIDES.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              data-testid={`hero-slide-${i}`}
              className={`h-1 rounded-full transition-all ${i === idx ? "bg-gold w-10" : "bg-cream/35 w-5 hover:bg-cream/55"}`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
